import { alpha } from '@mui/material/styles';

export default function Switch(theme) {
  const trackColor = alpha(
    theme.palette.text.primary,
    theme.palette.mode === 'light' ? 0.18 : 0.4
  );
  const hoverBg = alpha(theme.palette.primary.main, 0.18);
  const brandGradient = theme.palette.gradients.brand;

  return {
    MuiSwitch: {
      styleOverrides: {
        root: {
          padding: theme.spacing(0.5)
        },
        switchBase: {
          color: alpha(theme.palette.text.primary, 0.55),
          '&:hover': {
            backgroundColor: hoverBg
          },
          '&.Mui-checked': {
            color: theme.palette.common.white,
            '&:hover': {
              backgroundColor: hoverBg
            },
            '& + .MuiSwitch-track': {
              opacity: 1,
              backgroundImage: brandGradient
            }
          },
          '&.Mui-disabled': {
            color: alpha(theme.palette.text.disabled, 0.8)
          }
        },
        thumb: {
          boxShadow: 'none'
        },
        track: {
          borderRadius: 999,
          opacity: 1,
          backgroundColor: trackColor,
          transition: theme.transitions.create(['background-color'], {
            duration: theme.transitions.duration.shorter
          })
        }
      }
    }
  };
}
